import { allTrackers } from "app/services/track/track";
import type { track as TrackType } from "pro-features/components/WithTrack/src/context";

type FiltersTrackingEntity = {
    trackCountryToggle(): void;
    trackDateRangeToggle(): void;
    trackWebSourceToggle(): void;
    trackCountrySubmit(): void;
    trackWebSourceChange(webSource: string): void;
};

export const createFiltersTracking = (track: TrackType): FiltersTrackingEntity => {
    function trackCountrySubmit() {
        track("Top bar", "submit", "Country Filter");
    }

    function trackCountryToggle() {
        track("Top bar", "toggle", "Country Filter");
    }

    function trackDateRangeToggle() {
        track("Top bar", "toggle", "Date range Filter");
    }

    function trackWebSourceToggle() {
        track("Top bar", "toggle", `Header/WebSource Filter`);
    }

    function trackWebSourceChange(webSource: string) {
        track("Top bar", "click", `Header/WebSource Filter/${webSource}`);
    }

    return {
        trackCountrySubmit,
        trackCountryToggle,
        trackDateRangeToggle,
        trackWebSourceToggle,
        trackWebSourceChange,
    };
};

export default createFiltersTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
